/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   imgix constructUrl
 *                https://github.com/imgix/react-imgix/blob/master/src/constructUrl.js
 */

import { DEFAULT_OPTIONS } from './constants'
import constructUrlFromParams from './constructUrlFromParams'

/**
 * Construct a URL for an image with an Imgix proxy
 * For all the options available: [API reference docs](https://www.imgix.com/docs/reference).
 *
 * @param  {string} src         src of raw image
 * @param  {object} options     map of image API options
 * @returns {string}             imgix URL
 */
const constructUrl = (src, options) => {
  if (!src) {
    return ''
  }

  const params = options ? { ...DEFAULT_OPTIONS, ...options } : { ...DEFAULT_OPTIONS }

  return constructUrlFromParams(src, params)
}

export default constructUrl
